import Swal from 'sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { useFetchWithFiles } from '@/composables/useFetchWithFiles'

export function notificationErrorImportingPeople(pusher) {
  swalFire(pusher)
}

async function swalFire(pusher) {
  const { t } = useI18n()

  const html = textPreprocess(pusher)
  Swal.fire({
    title: t('Error Importing Personas'),
    icon: 'error',
    html: html,
    showDenyButton: true,
    confirmButtonText: t('Donwload'),
    denyButtonText: t('Ok'),
    showClass: {
      popup: 'animate__animated animate__slideInDown'
    }
  }).then(async result => {
    if (result.isConfirmed) {
      const { data, success } = await useFetchWithFiles(pusher.url, {}, 'GET')
      if (success) {
        Swal.fire({
          title: t(data.data),
          icon: 'info'
        })
      }
    }
  })
}

function textPreprocess(data) {
  const errors = getErrors(data)
  let html = ''
  if (errors.length > 0) {
    html = convertErrorsToHTML(errors)
  }
  return html
}

function getErrors(data) {
  const errors = data.error
  return errors
}

function convertErrorsToHTML(errors) {
  let html = `<p class="swal-longmessage">${t(errors)}</p>`

  return html
}
